<template>
  <div class="xcard mt-0 pt-1">
    <v-card class="ins-card elevation-3">
      <v-toolbar flat class="ins-hero" v-show="!es_simulacion_de_ins">
        <v-btn small class="mr-3" @click="$router.back()" color="white" outlined>
          <v-icon left>mdi-arrow-left-bold</v-icon>
          Volver
        </v-btn>
        <div>
          <div class="text-h6 white--text">Solicitud de pre inscripcion del estudiante</div>
          <div class="text-body-2 white--text">
            Configura el plan, aplica promocion y genera el cronograma de pagos
          </div>
        </div>
        <v-spacer></v-spacer> 
        <v-chip color="yellow darken-2" class="deep-orange--text text--darken-4" small>
          Paso final del asesor
        </v-chip>
      </v-toolbar>

      <v-card-text class="pt-4"> 
        <timelineProgreso v-show="!es_simulacion_de_ins" ref="reftimelineProgreso"/>

        <v-row dense>
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 blue--text">Resumen</div>
              <div class="text-body-2 text--secondary">
                <b>Programa:</b> {{ programa.codigo }} {{ programa.nombre_compuesto }}
              </div>
              <div class="text-body-2 text--secondary">
                <b>Programa registrado:</b> {{ programa.fecha_registro }}
              </div>
              <div class="text-body-2 text--secondary">
                <b>Matriculacion desde:</b> {{ programa.fecha_matricula }}
              </div>
              <div class="text-body-2 text--secondary">
                <b>Inicio del programa:</b> {{ programa.fecha_inicio }}
              </div>
              <div class="text-body-2 text--secondary">
                <b>Sede del programa:</b> {{ sede_data.nombre }} 
              </div>
              <div class="text-body-2 text--secondary">
                <b>Estudiante:</b> {{ $route.query.persona_name }}
              </div>
              <!-- <div class="text-body-2 text--secondary">
                <b>Dias clases semana:</b> {{ programa.dias_clases_semana }}
              </div> -->
              <div class="text-body-2 text--secondary">
                <b>Dias clases:</b> {{ programa.dias_semana }}
              </div>
              <!-- <div class="text-body-2 text--secondary">
                <b>Asesor ID:</b> {{ $route.query.asesor_id }}
              </div> -->
            </v-card>
          </v-col> 
        </v-row>

        <v-row dense>
          <v-col cols="12" md="6">
            <v-select
              v-model="tipo_inscripcion"
              :items="tipos_inscripcion"
              label="Tipo de inscripción"
              dense
              outlined
              clearable
              placeholder="Seleccione el tipo..."
              hide-details
            />
          </v-col>
          <v-col v-if="tipo_inscripcion === 'Internacional' || tipo_inscripcion === 'Modular'" cols="12" md="6">
            <v-autocomplete
              v-model="convenio_seleccionado"
              :items="convenios"
              :loading="loading_convenios"
              item-text="nombre"
              item-value="id"
              label="Institución / convenio certificacion"
              dense
              outlined
              clearable
              return-object
              hide-details
              prepend-inner-icon="mdi-domain"
              placeholder="Seleccione la institución..."
            />
          </v-col>
        </v-row>
        
        <v-row class="justify-center" dense> 
          <v-col v-if="tipo_inscripcion" cols="12" md="6">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2">Plan de pagos</div>
              <v-select
                v-model="plan_seleccionado"
                :items="planes_filtrados"
                :loading="loading_programa"
                item-text="nombre"
                item-value="plan_cobro_programa_id"
                label="Seleccione el plan"
                hide-details
                dense
                outlined
                placeholder="Seleccione..."
                return-object
              />

              <div v-if="plan_seleccionado" class="mt-3">
                <div class="text-body-2 text--secondary mb-1">Detalle de cobros</div>
                <div
                  v-if="editar_cuotas_cronograma && tipo_inscripcion != 'Modular'"
                  class="cuotas-editor"
                >
                  <v-row
                    v-for="(p, ind) in plan_seleccionado.cobros"
                    :key="ind"
                    dense
                    align="center"
                    class="mb-1"
                  >
                    <v-col cols="12" sm="8">
                      <v-chip
                        class="ma-1"
                        small
                        color="deep-orange lighten-5"
                      >
                        {{ p.nombre }}: Bs. {{ p.monto }} · max {{ p.cuotas }} cuotas
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        :value="obtenerCuotasConcepto(p)"
                        type="number"
                        min="1"
                        :max="obtenerMaxCuotasConcepto(p)"
                        step="1"
                        label="Cuotas"
                        dense
                        outlined
                        hide-details
                        @input="actualizarCuotasConcepto(p, $event)"
                        @blur="normalizarCuotasConcepto(p)"
                      />
                    </v-col>
                  </v-row>
                </div>
                <v-chip-group v-else column>
                  <v-chip
                    v-for="(p, ind) in plan_seleccionado.cobros"
                    :key="ind"
                    class="ma-1"
                    small
                    color="deep-orange lighten-5"
                  >
                    {{ p.nombre }}: Bs. {{ p.monto }} · max {{ p.cuotas }} cuotas
                  </v-chip>
                </v-chip-group>
              </div>

              <div v-if="promo && promo.id && generado && generado.plan_con_descuentos" class="mt-3">
                <div class="text-body-2 text--secondary mb-1">Plan con promocion</div>
                <v-chip-group column>
                  <v-chip
                    v-for="(p, ind) in generado.plan_con_descuentos"
                    :key="ind"
                    class="ma-1"
                    small
                    color="light-blue lighten-5"
                  >
                    {{ p.nombre }}: {{ p.monto }} ({{ p.promo_descuento }})
                  </v-chip>
                </v-chip-group>
              </div>
            </v-card>
          </v-col>

          <v-col v-if="tipo_inscripcion" cols="12" md="6">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2">Promociones ({{ promociones.length }}) </div>
              <v-select
                v-model="promo"
                :items="promociones"
                :loading="loading_promos" 
                item-text="nombre"
                item-value="id"
                label="Seleccione la promocion"
                dense
                outlined
                placeholder="Seleccione..."
                clearable
                return-object
              />
              <div v-if="promo && promo.id" class="mt-3">
                <div class="text-body-2">{{ promo.descripcion }}</div>
                <div class="text-body-2 text--secondary">Desde: {{ promo.fecha_inicio }}</div>
                <div class="text-body-2 text--secondary">Hasta: {{ promo.fecha_fin }}</div>
                <div class="text-body-2 text--secondary">Aprobado por: {{ promo.aprobado_por }}</div>
                <v-divider class="my-2"></v-divider>
                <div class="text-body-2 text--secondary mb-1">Beneficios</div>
                <v-chip-group column>
                  <v-chip
                    v-for="(d, ind) in promo.detalle_promocion"
                    :key="ind"
                    class="ma-1"
                    small
                    color="green lighten-5"
                  >
                    {{ d.nombre_concepto }}: {{ d.valor_descuento }} {{ d.is_porcentaje ? '%' : 'Bs.' }}
                  </v-chip>
                </v-chip-group>
              </div>
            </v-card>
          </v-col> 

          <v-col v-if="tipo_inscripcion === 'Modular' && (!convenio_seleccionado || !plan_seleccionado)" cols="12">
            <v-alert type="info" text dense class="mb-0">
              <v-icon left color="info">mdi-information</v-icon>
              Por favor, seleccione la <b>Institución / convenio</b> y el <b>Plan de pagos</b> para ver y seleccionar los módulos.
            </v-alert>
          </v-col>

          <v-col v-if="tipo_inscripcion === 'Modular' && convenio_seleccionado && plan_seleccionado" cols="12">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2 d-flex align-center justify-space-between flex-wrap">
                <span>Módulos (selección múltiple)</span>
                <v-chip color="deep-orange darken-1" dark small label v-if="resumen_modular">
                  Programa: {{ resumen_modular.tipoProgramaLabel }} | Precio por módulo: Bs. {{ resumen_modular.precioBaseModulo }}
                </v-chip>
              </div>

              <v-data-table
                v-model="modulos_seleccionados"
                :headers="headers_modulos"
                :items="modulos"
                :loading="loading_modulos"
                item-key="id"
                show-select
                dense
                hide-default-footer
                :items-per-page="-1"
                no-data-text="Sin módulos disponibles"
              />

              <v-alert v-if="resumen_modular && resumen_modular.valido" color="indigo" text dense class="mt-3 mb-0">
                <div class="d-flex align-center justify-space-between flex-wrap">
                  <div>
                    <v-chip color="indigo darken-1" dark label small class="mr-2">
                      {{ resumen_modular.cantModulos }} módulo(s) seleccionado(s)
                    </v-chip>
                    <v-chip :color="resumen_modular.porcentajeDescuento > 0 ? 'green darken-2' : 'orange darken-2'" dark label small>
                      Descuento aplicado: {{ resumen_modular.porcentajeDescuento }}% (-Bs. {{ resumen_modular.montoDescuento }})
                    </v-chip>
                  </div>
                  <div class="text-subtitle-2 blue-grey--text text--darken-3">
                    Total: Bs. {{ resumen_modular.subtotal }} | <b>Subtotal: Bs. {{ resumen_modular.total }}</b>
                  </div>
                </div>
                <v-divider v-if="resumen_modular.descuentoAplicadoLabel" class="my-2"></v-divider>
                <div v-if="resumen_modular.descuentoAplicadoLabel" class="text-caption d-flex align-center">
                  <v-icon small left color="indigo">mdi-information-outline</v-icon>
                  <span><strong>Información de Descuentos:</strong> {{ resumen_modular.descuentoAplicadoLabel }}</span>
                </div>
              </v-alert>
            </v-card>
          </v-col>

          <v-col v-if="generado && generado.plan && tipo_inscripcion" cols="12" class="mt-8">
            <v-row dense>
              <v-col cols="12" lg="7">
                <v-card outlined>
                  <v-card-title class="text-subtitle-2 d-flex align-center">
                    <p class="mb-0">Cronograma de pagos</p>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="modulos_programa.length"
                      x-small
                      text
                      color="blue darken-2"
                      @click="dialog_modulos_programa = true"
                    >
                      <v-icon x-small left>mdi-view-module</v-icon>
                      Ver módulos
                    </v-btn>
                    
                    <!-- <span>La fecha se genera a partir de la fecha de hoy</span> -->
                  </v-card-title>
                  <v-data-table
                    :headers="headers"
                    :items="plan_cronograma"
                    :items-per-page="150"
                    item-key="index"
                    hide-default-footer
                    class="elevation-1 tabla-pagos"
                    :item-class="rowClass"
                  >
                    <template v-slot:item.xnombre="{ item }">
                      <div>
                        <span>{{ item.xnombre }}</span>
                        <div v-if="item.modulo_nombre" class="caption grey--text text--darken-1 font-italic">
                          {{ item.modulo_nombre }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.monto="{ item }">
                      <span>Bs. {{ item.monto }}</span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>

              <v-col cols="12" lg="5" v-show="!es_simulacion_de_ins"> 
                <v-card outlined class="pr-4">
                  <ComprobantePago ref="refComprobantePago"
                        @comprobante-guardado="handleComprobanteGuardado($event,'comprobantex')"
                      />
                </v-card>

                <p class="mb-0 mt-3 py-0">Informacion opcional:</p>
                <!-- <v-btn class="purple" dark @click="opencliente()">
                  <v-icon small left>mdi-file</v-icon>
                  Datos para la factura
                </v-btn> -->

                <DataFacturas
                  ref="refDataFacturas"
                  :inscripcion-id="inscripcionId"
                  :razon-social-default="$route.query.persona_name || ''"
                  class="mb-3 mt-1"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col v-if="tipo_inscripcion && !es_simulacion_de_ins" cols="12" class="d-flex justify-center mt-8 pb-14 mb-10">
            <v-btn
              color="green"
              class="white--text"
              :loading="loading"
              :disabled="plan_cronograma.length === 0 || loading_promos || (tipo_inscripcion === 'Modular' && modulos_seleccionados.length === 0)"
              @click="realizar_ins()"
            >
              <v-icon left>mdi-check-circle</v-icon>
              Solicitar pre inscripcion
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <confirmarModal ref="refconfirmarModal" />

    <v-dialog v-model="dialog_modulos_programa" max-width="760" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1">
          <v-icon small left color="blue darken-2">mdi-view-module</v-icon>
          Módulos del programa
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialog_modulos_programa = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-data-table
            :headers="headers_modulos_programa"
            :items="modulos_programa"
            dense
            disable-pagination
            hide-default-footer
            no-data-text="Sin módulos disponibles"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <RegCliente ref="refRegCliente" v-on:newregcliente="onnewregcliente"/>
  </div>
</template>

<style scoped>
  .ins-card {
    border-radius: 16px;
    overflow: hidden;
  }
  .ins-hero {
    min-height: 90px;
    background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
  }
  ::v-deep .grupo-par {
    background-color: #fcfcfc!important;
  }

  ::v-deep .grupo-impar {
    background-color: #f1f5ff!important;
  }
</style>

<script>
  import { headers, getprograma, getpromociones,getpromocionesv3, generar_plan, generar_plan_v2, rowClassX,realizar_inscripcion_from_preins, generar_plan_v3 } from './utils';
  import { generarPlanModular, calcularResumenModular } from './utils-modular';
  import confirmarModal from './confirmar-modal.vue';
  import ComprobantePago from '@/components/ComprobantePago.vue';
  import DataFacturas from './data-facturas.vue';
  // import documentoFData from '@/components/documentoFData.vue';
  import timelineProgreso from '../timeline-progreso.vue';
  import { update_prospecto_estado } from '../utils';
import gql from 'graphql-tag';
import programaunis from '../../pagos/services/programa-universidad.service.js';
import RegCliente from '@/views/recibos/clientes/registrar.vue'

// Cambiar a true para habilitar la edición manual de cuotas por concepto.
const HABILITAR_EDICION_CUOTAS_CRONOGRAMA = true;
const HABILITAR_FECHAS_SEGUN_MODULOS = true;
const HABILITAR_FECHAS_SEGUN_MODULOS_CON_MAXCUOTAS = true;
const cuotaMinimaCronograma = 1;


  export default {
    components: {confirmarModal,ComprobantePago,timelineProgreso,RegCliente,
      DataFacturas
    },
    data() {
      return {
        loading: false,
        loading_programa: false,
        loading_promos: false,
        loading_modulos: false,
        loading_convenios: false,
        es_simulacion_de_ins: false,
        programa: {},
        sede_data:{},
        plan_seleccionado: null,
        promociones: [],
        promo: {},
        generado: {},
        cuotas_conceptos_cronograma: {},
        editar_cuotas_cronograma: HABILITAR_EDICION_CUOTAS_CRONOGRAMA,
        headers: headers,
        headers_modulos: [
          { text: '#', value: 'numero', width: '60px' },
          { text: 'Nombre', value: 'modulo.nombre' },
        ],
        headers_modulos_programa: [
          { text: '#', value: 'numero', width: '60px' },
          { text: 'Módulo', value: 'nombre' },
          { text: 'Inicio', value: 'fecha_inicio', width: '130px' },
          { text: 'Final', value: 'fecha_fin', width: '130px' },
        ],
        tipo_inscripcion: null,
        // tipos_inscripcion: ['Posgradual', 'Internacional', 'Modular'],
        tipos_inscripcion: ['Posgradual'],
        convenios: [],
        convenio_seleccionado: null,
        modulos: [],
        modulos_seleccionados: [],
        dialog_modulos_programa: false,
        comprobanteData: {xbase64:null},
        documentoData: {xbase64:null},
        facturaData: {},
      };
    },
    computed: {
      planes_filtrados() {
        if (!this.programa.planes) return [];
        // en un futuro no usar esto :( 
        const tipo = this.normalizarTexto(this.tipo_inscripcion)
        const esModular = /\bmodular\b/
        const esModularUpi = /\bmodular\b.*\bupi\b/

        if (tipo === 'modular') {
          if(this.convenio_seleccionado && this.convenio_seleccionado.nombre.includes('Universidad Politécnica Internacional')){
            return this.programa.planes.filter(x => esModularUpi.test(this.normalizarTexto(x.nombre)))
          }
          return this.programa.planes.filter(x => esModular.test(this.normalizarTexto(x.nombre)) && !esModularUpi.test(this.normalizarTexto(x.nombre)))
        
        } else if (this.tipo_inscripcion === 'Internacional') {
          return this.programa.planes.filter(p => p.nombre && p.nombre.toUpperCase().includes('INTERNACIONAL'));
        
        }else {
          return this.programa.planes.filter(p => {
            if (!p.nombre) return false;

            const nombre = p.nombre.toUpperCase();

            return !nombre.includes('MODULAR') &&
                  !nombre.includes('INTERNACIONAL');
          });
        }

        // return this.programa.planes
      },
      plan_cronograma() {
        if (!this.generado || !this.generado.plan) return [];
        return this.generado.plan;
      },
      modulos_programa() {
        const modulos = this.programa.programa_modulo || this.programa.programa_modulos || [];
        return modulos
          .map((modulo) => ({
            numero: modulo.numero,
            nombre: modulo.modulo?.nombre || modulo.nombre || '',
            fecha_inicio: modulo.fecha_inicio || '',
            fecha_fin: modulo.fecha_fin || modulo.fecha_final || '',
          }))
          .sort((a, b) => Number(a.numero || 0) - Number(b.numero || 0));
      },
      resumen_modular() {
        if (this.tipo_inscripcion !== 'Modular') return null;
        return calcularResumenModular({
          convenioId: this.convenio_seleccionado?.id || this.convenio_seleccionado,
          programa: this.programa,
          modulosSeleccionados: this.modulos_seleccionados,
          planSeleccionado: this.plan_seleccionado,
          promo: this.promo,
        });
      },
      inscripcionId() {
        return parseInt(this.$route.query.inscripcion_id);
      }, 
    },
    watch: {
      tipo_inscripcion(val) {
        this.modulos = [];
        this.modulos_seleccionados = [];
        this.plan_seleccionado = null;
        this.convenio_seleccionado = null;
        if (val === 'Modular') {
          this.promo = null;
          this.getModulos();
        }
        if (val === 'Internacional' || val == 'Modular') {
          this.getConveniosUniversidades();
        }
      },
      convenio_seleccionado() {
        if (this.tipo_inscripcion === 'Modular') {
          this.generar_plan_pagos();
        }
      },
      modulos_seleccionados() {
        if (this.tipo_inscripcion === 'Modular') {
          this.generar_plan_pagos();
        }
      },
      plan_seleccionado() {
        this.generado = {};
        this.promo = null;
        this.promociones = []
        this.inicializarCuotasConceptos()
        this.generar_plan_pagos()
        this.getpromos()

        this.$nextTick(() => { 
          this.$refs.refComprobantePago?.setCuentasBancarias(this.sede_data?.cuentasBancarias);
        });

      },
      promo() {
        // this.generado = {};
        this.generar_plan_pagos() 
      }
    },
    methods: {
      obtenerKeyConcepto(cobro) {
        return String(cobro.cobro_programa_id || cobro.concepto_id || cobro.nombre || '');
      },
      obtenerMaxCuotasConcepto(cobro) {
        const max = parseInt(cobro?.cuotas, 10);
        return max >= cuotaMinimaCronograma ? max : cuotaMinimaCronograma;
      },
      limitarCuotasConcepto(valor, max) {
        const cuotas = parseInt(valor, 10);
        if (!Number.isFinite(cuotas)) return cuotaMinimaCronograma;
        return Math.min(Math.max(cuotas, cuotaMinimaCronograma), max);
      },
      inicializarCuotasConceptos() {
        if (!this.editar_cuotas_cronograma || !this.plan_seleccionado) {
          this.cuotas_conceptos_cronograma = {};
          return;
        }

        const cuotasConceptos = {};
        (this.plan_seleccionado.cobros || []).forEach((cobro) => {
          const key = this.obtenerKeyConcepto(cobro);
          const max = this.obtenerMaxCuotasConcepto(cobro);
          cuotasConceptos[key] = this.limitarCuotasConcepto(this.cuotas_conceptos_cronograma[key] || max, max);
        });
        this.cuotas_conceptos_cronograma = cuotasConceptos;
      },
      obtenerCuotasConcepto(cobro) {
        if (!this.editar_cuotas_cronograma) return cobro.cuotas;
        const key = this.obtenerKeyConcepto(cobro);
        return this.cuotas_conceptos_cronograma[key] || this.obtenerMaxCuotasConcepto(cobro);
      },
      actualizarCuotasConcepto(cobro, valor) {
        const key = this.obtenerKeyConcepto(cobro);
        const max = this.obtenerMaxCuotasConcepto(cobro);
        const cuotas = this.limitarCuotasConcepto(valor, max);
        this.$set(this.cuotas_conceptos_cronograma, key, cuotas);
        this.generar_plan_pagos();
      },
      normalizarCuotasConcepto(cobro) {
        this.actualizarCuotasConcepto(cobro, this.obtenerCuotasConcepto(cobro));
      },
      aplicarCuotasConceptos(cobros) {
        if (!this.editar_cuotas_cronograma) return cobros;
        return cobros.map((cobro) => {
          const max = this.obtenerMaxCuotasConcepto(cobro);
          const cuotas = this.limitarCuotasConcepto(this.obtenerCuotasConcepto(cobro), max);
          return {
            ...cobro,
            cuotas,
            max_cuotas: max,
          };
        });
      },
      async getConveniosUniversidades() {
        // if (this.convenios.length) return;
        this.loading_convenios = true;
        const sql = gql`query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} }`;
        try {
          const { data } = await this.$apollo.query({ query: sql });
          let conves = data && data.getInstituciones ? data.getInstituciones : [];
          if(this.tipo_inscripcion == 'Internacional'){
            conves = conves.filter(x => x.convenio && (x.id == -9 || x.id == 301));
          } else if(this.tipo_inscripcion == 'Modular'){
            // conves = conves.filter(x => x.convenio && (x.id == 9 || x.id == 301));
            // solo mostrar siglo xx hasta que definan los precios para upi
            conves = conves.filter(x => x.convenio && (x.id == 9));
          }
          this.convenios = conves;
        } catch (e) {
          window.console.error(e);
          this.convenios = [];
          this.$root.$notify.show('No se pudieron cargar las instituciones convenio', { color: 'red', x: 'right' });
        } finally {
          this.loading_convenios = false;
        }
      },
      async getModulos() {
        this.loading_modulos = true;
        const programa_id = this.$route.params.programa_id || this.$route.query.programa_id;
        const qs = gql`query{ getPrograma(id: ${programa_id}) {id programa_modulos{id idmodulo numero modulo{id nombre}}} }`;
        const res = await this.$apollo.query({ query: qs }).then(({ data }) => (data.getPrograma ? data.getPrograma : { programa_modulos: [] }));
        // modulo 100 corresponde al modulo de titulacion que lo estamos quitando :)         
        this.modulos = (res.programa_modulos || []).filter(x=>x.numero != 100 && x.modulo?.nombre != 'Módulo De Titulacion').slice().sort((a, b) => a.numero - b.numero);
        this.loading_modulos = false;
      },
      handleComprobanteGuardado(data, tipo) {
        window.console.log("Comprobante guardado:", data);
        if(tipo == 'comprobantex'){
          this.comprobanteData.archivo = data.archivo
          this.comprobanteData.comentario = data.comentario
          this.comprobanteData.fechaPago = data.fechaPago
          this.comprobanteData.monto = data.monto
          this.comprobanteData.depositante = data.depositante
          this.comprobanteData.nrComprobante = data.nrComprobante
          this.comprobanteData.banco = data.banco
          this.comprobanteData.nroCuenta = data.nroCuenta
        }
        else if(tipo == 'documentox'){
          this.documentoData.archivo = data.archivo
          this.documentoData.comentario = data.comentario
          this.documentoData.fechaPago = data.fechaPago
          this.documentoData.monto = data.monto
          this.comprobanteData.depositante = data.depositante
          this.comprobanteData.nrComprobante = data.nrComprobante
          this.comprobanteData.banco = data.banco
          this.comprobanteData.nroCuenta = data.nroCuenta
        }

        if (!data.archivo) {
          window.console.error("Error: No se encontró un archivo en data.archivo");
          return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(data.archivo);
        reader.onload = () => {  // Usamos una arrow function para mantener el contexto de `this`
          if(tipo == 'comprobantex'){
            this.comprobanteData.archivoComprobante = reader.result.split(",")[1];
            this.comprobanteData.xbase64 = reader.result; 

          }else if(tipo == 'documentox') {
            this.documentoData.archivoComprobante = reader.result.split(",")[1];
            this.documentoData.xbase64 = reader.result; 
          }
        };
        reader.onerror = (error) => {
          window.console.error("Error al convertir el archivo a Base64:", error);
        }; 
      }, 
      es_curso(nombre){
        const es = nombre.toLowerCase().includes("esam cursos")
        return es
      },
      mark_campos_similados(){
        this.es_simulacion_de_ins = false
        const existe = this.$route.query.persona_id
        if(!existe) {
          this.es_simulacion_de_ins = true;
        }
      },
      async getprogramadata() {
        this.mark_campos_similados();
        this.loading_programa = true;
        const programa_id = this.$route.params.programa_id || this.$route.query.programa_id;
        const res = await getprograma(programa_id);
        this.loading_programa = false;
        if (!res.planes) res.planes = [];
        res.planes.forEach((x) => {
          x.cobros.forEach((c) => {
            if (c.monto == 1) c.monto = 0;
          });
        });
        // window.console.log('datos del programa::', res);

        const fecha_reg_programa = res.fecha_registro; //2026-07-03 08:15:12.791
        const fechaRegistro = new Date( fecha_reg_programa.replace(" ", "T") );
        // const hoy = new Date('2026-08-24T00:00:00-04:00') 
        const hoy = new Date('2026-08-25T00:00:00-04:00') 

        window.console.log(fechaRegistro);
        window.console.log(hoy);
        
        
        if(res && (!res.dias_semana && !this.es_curso(res.nombre_compuesto) && (fechaRegistro > hoy)) ) {
          if(!this.es_simulacion_de_ins){
            window.console.log('dias_semana', res);
            this.$root.$notify.show(`El programa ${res.nombre_compuesto}, no tiene configurado los dias semana`, { color: 'red', x: 'right', timeout: 10000 });
            this.$router.back()
            return
          }
        } 
       

        this.programa = res;
        this.programa.planes = res.planes.filter((x) => x.estado);
        const conv_id = this.programa.universidad_id;
        if(conv_id == 20){
          this.tipos_inscripcion = ['Posgradual'];
        }else {
          this.tipos_inscripcion = ['Posgradual', 'Internacional', 'Modular']
        }

        this.get_sede_data(this.programa.sede_id)
        this.getProgramaUniversidad(this.programa.programa_universidad_id || this.programa.universidad_id)
      },
      async getProgramaUniversidad(id){
        this.loading = true
        const res = await programaunis.findOne(id)
        this.loading = false
        if(res && res.data){
          const programa_id = this.$route.params.programa_id || this.$route.query.programa_id;
          // este xprograma, no se donde se usa :( tal ves haya que quitarlo
          res.data.datos.xprograma = res.data.datos.programas.find(x=>x.id == programa_id)
          window.console.log('xxxgetProgramaUniversidad', res.data.datos);
          
        }         
      },
      async getpromos() {
        this.loading_promos = true;
        this.promociones = []
        const programa_id = this.$route.params.programa_id || this.$route.query.programa_id;
        const res = await getpromociones(programa_id);
        this.loading_promos = false;
        window.console.log('getpromos',res.data);
        
        if (res && res.data) {
          res.data = this.filtrar_promos(res.data)
          this.promociones.push(...res.data);

          if (res.data.length == 1 && this.tipo_inscripcion !== 'Modular') {
            this.promo = res.data[0];
          }
        } 
        void this.getpromosv3()
      },
      async getpromosv3() {
        if(!this.plan_seleccionado) return;
        
        this.loading_promos = true; 
        const programa_id = this.$route.params.programa_id || this.$route.query.programa_id;
        const res = await getpromocionesv3(programa_id, this.plan_seleccionado.plan_cobro_programa_id);
        window.console.log('getpromosv3',res.data);
        
        this.loading_promos = false;
        if (res && res.data) {
          res.data = this.filtrar_promos(res.data)
          res.data.map(x=>{
            x.fecha_inicio = x.fechas[0]?.fecha_inicio
            x.fecha_fin = x.fechas[0]?.fecha_fin
            x.detalle_promocion = []
            x.reglas.forEach(r=>{
              r.conceptos.forEach(c=> x.detalle_promocion.push(c))
            })

          })
          this.promociones.push(...res.data);
          if (res.data.length == 1 && this.tipo_inscripcion !== 'Modular') {
            this.promo = res.data[0];
          }
        }
      },
      // HARCODEADO, lo ideal seria que el endpoint devuelva las promos segun el tipo inscripcion y segun convenio
      filtrar_promos(promos){
        const tipo = this.normalizarTexto(this.tipo_inscripcion)
        const esModular = /\bmodular\b/

        if (tipo === 'modular') {
          promos = promos.filter(x => esModular.test(this.normalizarTexto(x.nombre)))
        } else if (tipo === 'posgradual' || tipo === 'internacional') {
          promos = promos.filter(x => !esModular.test(this.normalizarTexto(x.nombre)))
        }
        return promos
      },
      normalizarTexto(texto){
        return String(texto || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim()
          .toLowerCase();
      },
      filtrar_planes_modulares(){},
      // FIN HARDCODEADO

      rowClass(item) {
        return rowClassX(item, this.incluir_deuda_q10_in_plan);
      },
      generar_plan_pagos() {
        if (this.tipo_inscripcion === 'Modular') { 
          if(this.promo && this.promo.nombre.includes('5%') && this.modulos_seleccionados.length < 3){
            this.$root.$notify.show('Promoción aplicable únicamente a partir de 3 módulos', { color: 'red', x: 'right', timeout: 6000 });
            this.$nextTick(() => {
              this.promo = null;
            });
            return;
          }
          else if(this.promo && this.promo.nombre.includes('5%') && this.modulos_seleccionados.length > 6){
            this.$root.$notify.show('Promoción aplicable de 3 a 5 módulos', { color: 'red', x: 'right', timeout: 6000 });
            this.$nextTick(() => {
              this.promo = null;
            });
            return;
          }
          else if(this.promo && this.promo.nombre.includes('10%') && this.modulos_seleccionados.length < 6){
            this.$root.$notify.show('Promoción aplicable únicamente a partir de 6 módulos', { color: 'red', x: 'right', timeout: 6000 });
            this.$nextTick(() => {
              this.promo = null;
            }); 
            return;
          }
        
          const res = generarPlanModular({
            convenioId: this.convenio_seleccionado?.id || this.convenio_seleccionado,
            programa: this.programa,
            modulosSeleccionados: this.modulos_seleccionados,
            planSeleccionado: this.plan_seleccionado,
            promo: this.promo,
          });
          this.generado = {
            plan: res.plan,
            resumenModular: res.resumen,
          };
          return;
        }

        if(!this.plan_seleccionado) return;
        const cobros = JSON.parse(JSON.stringify(this.plan_seleccionado.cobros));
        
        if(HABILITAR_FECHAS_SEGUN_MODULOS_CON_MAXCUOTAS){
          const res = generar_plan_v3(this.promo, this.aplicarCuotasConceptos(cobros), this.programa);
          window.console.log(res);
          this.generado = res; 
        
        } else if(HABILITAR_FECHAS_SEGUN_MODULOS){
          const res = generar_plan_v2(this.promo, this.aplicarCuotasConceptos(cobros), this.programa);
          window.console.log(res);
          this.generado = res;
        
        }else{
          const res = generar_plan(this.promo, this.aplicarCuotasConceptos(cobros), this.programa);
          window.console.log(res);
          this.generado = res; 
        }
      }, 
      async saveEstadoProspecto(estado){
        if(!this.$route.query.prospecto_id) return;

        const dt = {
          prospecto_id: this.$route.query.prospecto_id,
          estado: estado
        }
        await update_prospecto_estado(dt)
      },
      async realizar_ins(){
        if (this.tipo_inscripcion === 'Modular') {
          if (!this.convenio_seleccionado) {
            this.$root.$notify.show('Debe seleccionar la institución / convenio', { color: 'red', x: 'right' });
            return;
          }
          if (this.modulos_seleccionados.length === 0) {
            this.$root.$notify.show('Debe seleccionar al menos un módulo', { color: 'red', x: 'right' });
            return;
          }
        }
        if (this.tipo_inscripcion === 'Internacional' && !this.convenio_seleccionado) {
          this.$root.$notify.show('Debe seleccionar la institución convenio', { color: 'red', x: 'right' });
          return;
        }
        if(!this.comprobanteData || !this.comprobanteData.xbase64){
          this.$root.$notify.show('Debe subir el comprobante de pago', { color: 'red', x: 'right' });
          return;
        }

        this.loading = true;

        const resumen = {
          tipo_inscripcion: this.tipo_inscripcion.toUpperCase(),
          programa: `${this.programa.codigo || ''} ${this.programa.nombre_compuesto || ''}`.trim(),
          estudiante: this.$route.query.persona_name || '',
          plan: this.plan_seleccionado ? this.plan_seleccionado.nombre : 'Plan Modular',
          promocion: (this.promo && this.promo.id) ? this.promo.nombre : 'Sin promocion',
          convenio: (this.convenio_seleccionado && this.convenio_seleccionado.id) ? this.convenio_seleccionado.nombre : null,
          modulos: this.modulos_seleccionados.map((modulo) => `${modulo.numero}. ${modulo.modulo?.nombre || ''}`.trim()),
          plan_pagos: this.plan_cronograma,
          comprobante: !!(this.comprobanteData && (this.comprobanteData.xbase64 || this.comprobanteData.archivoComprobante)),
          documento: !!(this.documentoData && (this.documentoData.xbase64 || this.documentoData.archivoComprobante)),
          factura: this.facturaData,
        };

        this.loading = true;
        const facturaGuardada = await this.$refs.refDataFacturas.guardar();
        if (!facturaGuardada) {
          this.loading = false;
          return;
        }
        if(facturaGuardada){          
          resumen.factura = {
            razon_social:facturaGuardada.razon_social,
            numero_documento: facturaGuardada.nit_ci
          }
        }

        const aceptar = await this.$refs.refconfirmarModal.openmodal(resumen);
        if (!aceptar) {
          this.loading = false;
          return;
        } 

        const inscrip = {
            asesor_id: parseInt(this.$route.query.asesor_id),
            canal_id: null,
            estudiante_id: parseInt(this.$route.query.persona_id),
            plan_cobro_programa_id: this.plan_seleccionado ? this.plan_seleccionado.plan_cobro_programa_id : null,
            programa_id: parseInt(this.$route.params.programa_id),
            registrado_por: this.$store.state.DATA_USER.id,
            tipo_pago: true,
            plan_pagos: this.plan_cronograma,
            tipo_inscripcion: this.tipo_inscripcion.toUpperCase(),
            modulos: this.modulos_seleccionados.map((modulo) => ({
              programa_modulo_id: modulo.id, // verificar si corresponde
              nombre: modulo.modulo ? modulo.modulo.nombre : null,
              id: modulo.id,
              idmodulo: modulo.idmodulo,
              numero: modulo.numero,
            })),
            // observaciones: '',
        }

        if (this.convenio_seleccionado) inscrip.universidad_id = this.convenio_seleccionado.id;

        // ponemos el id de la promocion
        if(this.promo && this.promo.id) inscrip.promocion_id = this.promo.id;

        if (this.comprobanteData && this.comprobanteData.xbase64){ 
          inscrip.comprobante_pago = {
            "depositante": this.comprobanteData.depositante,
            "nrComprobante": this.comprobanteData.nrComprobante,
            "banco": this.comprobanteData.banco,
            "nroCuenta": this.comprobanteData.nroCuenta,
            "monto": this.comprobanteData.monto,
            "fechaHoraDeposito": this.comprobanteData.fechaPago,
            "comentario": this.comprobanteData.comentario,
            "base64Archivo": this.comprobanteData.xbase64.split(',')[1],
          }
        }

        if(this.facturaData && this.facturaData.razon_social){
          inscrip.datos_factura = this.facturaData;
        }

        inscrip.inscripcion_id = parseInt(this.$route.query.inscripcion_id)
        const res2 = await realizar_inscripcion_from_preins(inscrip);

        if(res2 && res2.error){
          this.$root.$notify.show(res2.error, { color: 'red', x: 'right' });
        }else if(res2 && res2.inscripcion_id){
          this.$root.$notify.show(`Solicitado correctamente ID: ${res2.inscripcion_id}, ahora comunica al area contable de '${this.sede_data.nombre}' debe emitir el recibo`, { color: 'purple', x: 'right', timeout: 15000, y:'bottom' });
          this.loading = false;
          this.$router.back()

        }else{
          window.console.log('res2',res2);
        }

        this.loading = false;
        
      },
      async get_sede_data(sede_id){
        const sql = gql`query{getSede(id: ${sede_id}) { id, nombre, cuentasBancarias{ id, nombre, descripcion, nro, estado } ${''}}}`;
        const res = await this.$apollo.query({ query: sql }).then(({ data }) => data ).catch(e=>e)
        if(res && res.getSede) this.sede_data = res.getSede;
        // window.console.log('sedeeee', this.sede_data); 
      },

      // datos para la factura
      opencliente(){
        this.$refs.refRegCliente.openmodal();
      },
      onnewregcliente(cliente){
        window.console.log('cliente',cliente);
        this.facturaData = cliente;
      },
    },
    mounted() { 
      this.facturaData = {};
      this.$nextTick(() => {
        this.$refs.reftimelineProgreso.iniciar(2, false); 
      }); 
      this.getprogramadata();
    },
  };
</script>
